import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

// Resolve the timezone a calendar widget should render in: the timezone the
// backend planned the event in, falling back to the browser zone for older
// payloads that did not carry one.
export const resolveWidgetTimezone = (timezone) =>
  timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

// datetime-local <input> value (naive "YYYY-MM-DDTHH:mm") rendered in `tz`.
export const toLocalInputValue = (isoValue, tz) => {
  const parsed = dayjs(isoValue).tz(tz);
  return parsed.isValid() ? parsed.format("YYYY-MM-DDTHH:mm") : "";
};

// Inverse of toLocalInputValue: interpret the naive input string as wall-clock
// time in `tz` and return an absolute ISO instant.
export const fromLocalInputValue = (value, tz) => {
  if (!value) return null;
  const parsed = dayjs.tz(value, tz);
  return parsed.isValid() ? parsed.toDate().toISOString() : null;
};

// Human-readable "Thu 11 Jun, 8:00 PM - 9:00 PM" range, rendered in `tz` and
// always in 12-hour format with AM/PM.
export const formatTimeRange = ({ startDateTimeIso, endDateTimeIso }, tz) => {
  const startDate = new Date(startDateTimeIso);
  const endDate = new Date(endDateTimeIso);
  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
    return "Time not set";
  }

  const datePart = new Intl.DateTimeFormat(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    timeZone: tz,
  }).format(startDate);
  const timeFormatter = new Intl.DateTimeFormat(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: tz,
  });

  return `${datePart}, ${timeFormatter.format(startDate)} - ${timeFormatter.format(endDate)}`;
};
